const MIB = 1024 * 1024;
const KIB = 1024;

/**
 * A size the way the boards write it: `412 КБ`, `4,1 МБ`, `48 МБ`, `25 МБ` (the limits of the contract are binary: 25 MB = 25 · 1024 · 1024 bytes).
 * Under 10 MB one decimal, from 10 MB on whole megabytes.
 */
export function formatSize(bytes: number, lang = 'ru'): string {
  const ru = lang !== 'en';
  const comma = ru ? ',' : '.';
  const [kb, mb] = ru ? ['КБ', 'МБ'] : ['KB', 'MB'];
  if (bytes < KIB) {
    return `${Math.max(0, Math.round(bytes))} ${ru ? 'Б' : 'B'}`;
  }
  if (bytes < MIB) {
    return `${Math.round(bytes / KIB)} ${kb}`;
  }
  const value = bytes / MIB;
  if (value >= 10) {
    return `${Math.round(value)} ${mb}`;
  }
  const text = value.toFixed(1);
  return `${(text.endsWith('.0') ? text.slice(0, -2) : text).replace('.', comma)} ${mb}`;
}

/** `m:ss` of a number of seconds (`18` → `0:18`, `102` → `1:42`); under zero is zero. */
export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.round(seconds));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** `m:ss` of milliseconds, rounded to the second. */
export function formatClockMs(ms: number): string {
  return formatClock(ms / 1000);
}

/** The extension of a file name in capitals, without the dot: `IMG_2207.heic` → `HEIC`; none → an empty text. */
export function extensionOf(fileName: string | null | undefined): string {
  const name = fileName ?? '';
  const dot = name.lastIndexOf('.');
  return dot > 0 && dot < name.length - 1 ? name.slice(dot + 1).toUpperCase() : '';
}

/** `ru` or `en`: the languages the texts of the page have (anything else reads as Russian). */
export function pageLang(lang: string | undefined): 'ru' | 'en' {
  return lang === 'en' ? 'en' : 'ru';
}

/** The two sides the way the boards write them: `3024 × 4032`. */
export function formatDimensions(width: number, height: number): string {
  return `${width} × ${height}`;
}
